import { render, staticRenderFns } from "./About.vue?vue&type=template&id=9a205bb4&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=9a205bb4&prod&lang=css"
import style1 from "./About.vue?vue&type=style&index=1&id=9a205bb4&prod&scoped=true&lang=css"
import style2 from "./About.vue?vue&type=style&index=2&id=9a205bb4&prod&lang=scss"
import style3 from "./About.vue?vue&type=style&index=3&id=9a205bb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a205bb4",
  null
  
)

export default component.exports